import { Component, ViewChild } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { createSelector, Store } from "@ngrx/store";
import { isNil } from "lodash";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { convertCentsToDollars } from "src/app/lib.ts/currency.util";
import { LibModule } from "src/app/lib.ts/lib.module";
import { ArrayMinLenghtDirective } from "src/app/shared/array-min-length.directive";
import { SharedModule } from "src/app/shared/shared.module";

import { FullDiscountFragment } from "../../../generated/graphql.generated";
import { brandingFeature } from '../../state/branding.store';
import { JobEventSelectComponent } from "../event-select/event-select.component";
import { selectJob } from "../job-tool.reducer";
import { jobWorkordersFeature } from "../job-workorders/job-workorders.feature";
import { JobMutateDiscountComponent } from "../mutate-discount/mutate-discount.component";

import { AddDiscountsModalActions } from "./add-discounts-modal.actions";
import { addDiscountsModalFeature } from "./add-discounts-modal.feature";

@Component({
    selector: 'app-discounts-modal',
    standalone: true,
    imports: [
        SharedModule,
        LibModule,
        ReactiveFormsModule,
        FreyaCommonModule,
        JobEventSelectComponent,
        JobMutateDiscountComponent,
        ArrayMinLenghtDirective,
    ],
    templateUrl: './add-discounts-modal.component.html',
    styleUrl: './add-discounts-modal.component.scss',
})

export class AddDiscountsModalComponent {
    @ViewChild('mutate') mutateRef: JobMutateDiscountComponent;

    constructor(
        public store: Store,
    ) { }

    public actions = AddDiscountsModalActions;

    public viewModel$ = this.store.select(createSelector(
        addDiscountsModalFeature.selectAddDiscountsModal,
        jobWorkordersFeature.selectAvailableDiscounts,
        selectJob,
        brandingFeature.selectCurrency,
        (
            {
                visible,
                discountId,
                amount: amountValue,
                eventIds,
            },
            availableDiscounts,
            job,
            zoneCurrency,
        ) => {

            const selectedDiscount = availableDiscounts.find((d) => d.id === discountId);

            const amount = {
                value: amountValue,
                disabled: !selectedDiscount || !selectedDiscount.customAmountRange,
                min: undefined as number | undefined,
                max: undefined as number | undefined,
            };

            if (selectedDiscount?.customAmountRange) {
                const [ customMin, customMax ] = selectedDiscount.customAmountRange;
                amount.min = customMin;
                amount.max = customMax;
            }

            if (selectedDiscount?.discountType === 'amount') {
                amount.min = convertCentsToDollars(amount.min, true);
                amount.max = convertCentsToDollars(amount.max, true);
            }

            return {
                visible,
                discountId,
                amount,
                eventIds,
                availableDiscounts,
                currency: job?.currency || zoneCurrency,
                selectedDiscount,
                disabled: !selectedDiscount || isNil(amountValue) || !eventIds.length,
            };

        }
    ));

    public getDiscountAmountById(discountId: string, availableDiscounts: FullDiscountFragment[]) {
        const selectedDiscount = availableDiscounts.find((discount) => discount.id === discountId);
        if (!selectedDiscount) {
            return 0;
        }
        return selectedDiscount.discountType === 'percentage'
            ? selectedDiscount.amount
            : convertCentsToDollars(selectedDiscount.amount, true);
    }
}
